import { render, staticRenderFns } from "./Identify.vue?vue&type=template&id=2ed71a64&scoped=true&"
import script from "./Identify.vue?vue&type=script&lang=js&"
export * from "./Identify.vue?vue&type=script&lang=js&"
import style0 from "./Identify.vue?vue&type=style&index=0&id=2ed71a64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed71a64",
  null
  
)

export default component.exports